
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcPoiAton as ObcPoiAtonElement} from '@oicl/openbridge-webcomponents/dist/ar/poi-aton/poi-aton.js';
 
 
 

 
 export const ObcPoiAton = createComponent({
   react: React,
   tagName: 'obc-poi-aton',
   elementClass: ObcPoiAtonElement,
   events: {
     
     onObcPoiDataLayoutChange: 'obc-poi-data-layout-change' as EventName<CustomEvent<void>>,
   }
  });
 
 